import { ArrowBack } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

export default function Back(){

    return (

        <div className="apply-back">

            <Link to="/">

                <Stack direction="row" alignItems="center" spacing={1}>

                    <ArrowBack />

                    <span>Retour à l'accueil</span>

                </Stack>

            </Link>

        </div>
    );
}